export function setRecruiterProfileText(): void {
    const profile: HTMLElement | null = document.querySelector(`.profile-recruiter-bio__container`);

    if(!profile) return

    const title: HTMLElement | null = document.createElement("h3");
    title.classList.add(`profile-recruiter-bio__title`);
    title.innerText = `{{js.recruiter-bio-title}}`;

    profile.prepend(title);
}